import { GOAL_CARD_IMAGES } from '@fruitful/agent-ui';
import { Image, type ImageSourcePropType } from 'react-native';
import { isWeb } from 'smoothie';

// react-native-web doesn't implement Image.resolveAssetSource, but bundled
// image imports on web already resolve to a `{ uri }` object, so we can read
// the uri directly without it.
const getWebUri = (source: ImageSourcePropType): string | null => {
    if (Array.isArray(source)) return null;
    if (typeof source === 'string') return source;
    if (typeof source === 'object' && typeof source.uri === 'string') {
        return source.uri;
    }
    return null;
};

/**
 * Warms the browser's image cache for the goal summary card illustrations
 * well before the goal card widget itself ever mounts (it's typically shown
 * several turns into the conversation). Bundled native images don't need
 * this - they ship in the app binary and only pay a (now-cheap) decode cost -
 * so this only does anything on web, where each illustration is otherwise
 * fetched over HTTP the first time the widget renders.
 */
export const preloadGoalCardImages = () => {
    if (!isWeb) return;

    Object.values(GOAL_CARD_IMAGES).forEach((source) => {
        const uri = getWebUri(source);
        if (uri != null && uri.length > 0) {
            Image.prefetch(uri).catch(() => {
                // Best-effort warmup only; the widget's own load will retry.
            });
        }
    });
};
